import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { update_page_meta } from "../../actions/page/header";
// import { useSelectedOrganizations } from "../../reducers/accounts/user";
import { Link } from "react-router-dom";
import PageHeader from "../../components/page/PageHeader";
import OrganizationScroller from "../../components/OrganizationScroller";
import { useLocation, useNavigate } from "react-router-dom";
import { HomePageURL } from "../../assets/const";
import { createInvoice, listInvoices } from "../../actions/invoices/invoices";

const InvoiceList = ({ update_page_meta }) => {
  update_page_meta({
    title: "Invoices",
    description: "Invoices generated for orders",
  });
  const location = useLocation();
  const navigate = useNavigate();

  // Initialize searchParams from the current URL
  const [searchParams, setSearchParams] = useState(
    new URLSearchParams(location.search)
  );
  // Get values from searchParams
  const order = searchParams.get("order");
  const branch = searchParams.get("branch")?.split(",") || [];

  // Set a new `order` in URL
  const setOrder = (orderId) => {
    const newParams = new URLSearchParams(searchParams);
    if (orderId) {
      newParams.set("order", orderId);
    } else {
      newParams.delete("order");
    }
    updateURLParams(newParams);
  };

  // Set new branches in URL (array of IDs)
  const setBranch = (branchIds) => {
    const newParams = new URLSearchParams(searchParams);
    if (branchIds.length > 0) {
      newParams.set("branch", branchIds.join(","));
    } else {
      newParams.delete("branch");
    }
    updateURLParams(newParams);
  };

  // Update the browser URL and state
  const updateURLParams = (newParams) => {
    setSearchParams(newParams);
    navigate(
      { pathname: location.pathname, search: newParams.toString() },
      { replace: true }
    );
  };
  const [Invoices, setInvoices] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(18);
  const [fetching, setFetching] = useState(false);
  const bottomElementRef = useRef();

  useEffect(() => {
    const fetchMore = async () => {
      if (page > totalPages || fetching) return;
      try {
        setFetching(true);
        const response = await listInvoices(page, perPage, order, branch);
        if (response.results) {
          setInvoices((prevInvoices) => {
            if (page === 1) {
              return response.results; // Set the initial invoices
            } else {
              return [...prevInvoices, ...response.results]; // Append new invoices
            }
          });
          setTotalPages(response.num_pages);
          setPage(page + 1);
        }
      } catch (error) {
        console.error("Error fetching more products:", error);
      } finally {
        setFetching(false);
      }
    };
    const options = {
      root: null, // viewport
      rootMargin: "0px",
      threshold: 0.1, // When 10% of the element is visible, trigger the callback
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        fetchMore();
      }
    }, options);

    const bottomElement = bottomElementRef.current;

    if (bottomElement) {
      observer.observe(bottomElement);
    }

    return () => {
      if (bottomElement) {
        observer.unobserve(bottomElement);
      }
    };
  }, [bottomElementRef, page, totalPages, fetching]);
  const [invoiceCreating, setInvoiceCreating] = useState(false);
  const createNewInvoice = async () => {
    if (!order) {
      console.error("No order selected to create an invoice.");
      return;
    }
    setInvoiceCreating(true);
    try {
      const response = await createInvoice(order);
      if (response.success) {
        setInvoices((prevInvoices) => [response.invoice, ...prevInvoices]);
      } else {
        window.alert(`Failed to create invoice: ${response.detail}`);
      }
    } catch (error) {
      console.error("Error creating invoice:", error);
      window.alert("An error occurred while creating the invoice.");
    } finally {
      setInvoiceCreating(false);
    }
  };
  return (
    <>
      <PageHeader title="Invoices" />
      <div className="row layout-top-spacing" id="cancel-row">
        <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
          <div className="widget-content widget-content-area br-6">
            {order && (
              <button
                class="btn btn-primary mb-2 me-2"
                onClick={() => createNewInvoice()}
                disabled={invoiceCreating}
              >
                Create Invoice
              </button>
            )}
            {/* <OrganizationScroller /> */}
            <div className="table-responsive mb-4 mt-4">
              <table
                id="zero-config"
                className="table table-hover"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th className="no-content"></th>
                    <th>Invoice No</th>
                    <th>Order Reference</th>
                    <th>Date</th>
                    <th>Invoice Type</th>
                    <th>Status</th>
                    <th className="no-content"></th>
                  </tr>
                </thead>
                <tbody>
                  {Invoices?.map((invoice) => {
                    return (
                      <tr key={invoice?.id}>
                        <td></td>
                        <td>{invoice?.invoice_no || "-"}</td>
                        <td>{invoice?.order_reference}</td>
                        <td>{invoice?.date || "-"}</td>
                        <td>{invoice?.invoice_type}</td>
                        <td>{invoice?.status}</td>
                        <td className="cursor-pointer">
                          <Link to={`${HomePageURL}/invoices/${invoice?.id}/`}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              className="feather feather-arrow-right"
                            >
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                              <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                  {Invoices.length === 0 && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No invoices found.
                      </td>
                    </tr>
                  )}
                </tbody>
                <tfoot ref={bottomElementRef}></tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { update_page_meta })(InvoiceList);
